import { z } from 'zod';
import { PapelSchema } from '../comum/papeis';

export const PapelMaquinaSchema = z.enum(['PC', 'VPS']);
export type PapelMaquina = z.infer<typeof PapelMaquinaSchema>;

export const EstadoMaquinaSchema = z.enum(['ONLINE', 'OFFLINE']);
export type EstadoMaquina = z.infer<typeof EstadoMaquinaSchema>;

export const RaizPermitidaSchema = z.object({
  caminho: z.string().min(1).max(500),
  modo: z.enum(['rw', 'ro']),
});
export type RaizPermitida = z.infer<typeof RaizPermitidaSchema>;

export const CriarMaquinaSchema = z.object({
  nome: z
    .string()
    .min(2)
    .max(60)
    .regex(/^[a-z0-9][a-z0-9-]*$/, 'use minúsculas, dígitos e hífen'),
  papel: PapelMaquinaSchema,
  raizesPermitidas: z.array(RaizPermitidaSchema).max(20).default([]),
  capacidadeSdk: z.number().int().min(0).max(16).default(1),
  visibilidade: PapelSchema.default('OPERADOR'),
});
export type CriarMaquina = z.infer<typeof CriarMaquinaSchema>;

export const AtualizarMaquinaSchema = CriarMaquinaSchema.partial().refine(
  (v) => Object.keys(v).length > 0,
  'informe ao menos um campo',
);
export type AtualizarMaquina = z.infer<typeof AtualizarMaquinaSchema>;

export const MaquinaSchema = z.object({
  id: z.string(),
  nome: z.string(),
  papel: PapelMaquinaSchema,
  estado: EstadoMaquinaSchema,
  versaoAgente: z.string().nullable(),
  versaoClaude: z.string().nullable(),
  so: z.string().nullable(),
  raizesPermitidas: z.array(RaizPermitidaSchema),
  capacidadeSdk: z.number().int(),
  visibilidade: PapelSchema,
  loginMestreOk: z.boolean().nullable(),
  loginTrabalhoOk: z.boolean().nullable(),
  loginExpiraEm: z.iso.datetime().nullable(),
  memoriaLivreMb: z.number().int().nullable(),
  ultimoPulsoEm: z.iso.datetime().nullable(),
});
export type Maquina = z.infer<typeof MaquinaSchema>;

export const CriarTokenSchema = z.object({
  nome: z.string().min(2).max(60),
});
export type CriarToken = z.infer<typeof CriarTokenSchema>;

/** O segredo aparece uma única vez, na criação. Depois só o prefixo. */
export const TokenCriadoSchema = z.object({
  id: z.string(),
  prefixo: z.string(),
  segredo: z.string(),
  nome: z.string(),
});
export type TokenCriado = z.infer<typeof TokenCriadoSchema>;

export const PREFIXO_TOKEN_DISPOSITIVO = 'rmt_';
